import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { slugify } from '@/utils/funtion';
import Empty from '@/components/atoms/empty';
import MapsPackage, { AreaVariant } from '../../mapsPackage';
import ChartPackageSkeleton from '@/components/molecules/skeleton-component/chartPacakge';
import { InitialData } from '../types';

const ChartPackage = dynamic(
  () => import('@/components/templates/chartPackage'),
  {
    ssr: false,
    loading: () => {
      return <ChartPackageSkeleton />;
    },
  },
);

interface ChartDisplayProps {
  hasMap?: boolean;
  area?: AreaVariant;
  chartData: any;
  initialData: InitialData;
  type: string;
  handleSelectTime: (value: string) => void;
  handleGetChartDataByRange: (
    item: any,
    type: string,
    isStructure: number,
  ) => void;
}

const ChartDisplay: React.FC<ChartDisplayProps> = ({
  hasMap,
  area = 'VN',
  chartData,
  initialData,
  type,
  handleSelectTime,
  handleGetChartDataByRange,
}) => {
  const mappingData: Record<string, any> = {
    indicator: chartData?.values?.indicator,
    industryIndicator: chartData?.values?.industryIndicator,
    localIndicator: chartData?.values?.localIndicator,
  };

  const memoryChart = useMemo(() => {
    if (!chartData)
      return (
        <div className="indicator-session-chart_empty">
          <Empty />
        </div>
      );

    if (
      hasMap ||
      (initialData.key === 'localIndicator' &&
        !!chartData?.values?.localIndicator?.map?.length) ||
      !!initialData?.value?.map?.length
    ) {
      return (
        <MapsPackage
          area={area}
          id={chartData?.id}
          dataMaps={chartData?.values?.localIndicator?.map || []}
          original={chartData?.original}
          originalUrl={chartData?.originalUrl}
          loading={chartData?.loading}
          unit={chartData?.unit}
          mapTitle={chartData?.name}
          timeData={chartData?.yearList}
          onSelectTime={handleSelectTime}
          dataType={chartData?.dataType}
          chartType={chartData?.chartType}
        />
      );
    }

    const data =
      !chartData?.isStructure &&
      !chartData?.isTwoUnit &&
      !chartData?.isObjectOneTime
        ? mappingData[initialData.key]?.often
          ? mappingData[initialData.key]?.often
          : mappingData[initialData.key]?.chart
        : mappingData[initialData.key]?.children?.length
          ? mappingData[initialData.key]?.children
          : mappingData[initialData.key]?.children?.response
            ? mappingData[initialData.key]?.children?.response
            : mappingData[initialData.key]?.chart;

    return (
      <ChartPackage
        data={data}
        isStructure={chartData?.isStructure}
        name={chartData?.name}
        slug={slugify(chartData?.name)}
        id={chartData?.id}
        original={chartData?.original}
        originalUrl={chartData?.originalUrl}
        unit={chartData?.unit}
        loading={chartData?.loading}
        dataType={chartData?.dataType}
        chartType={chartData?.chartType || 'column'}
        isTwoUnit={chartData?.isTwoUnit}
        isObjectOneTime={chartData?.isObjectOneTime}
        handleClickRangeTime={(item) => {
          handleGetChartDataByRange(item, type, chartData?.isStructure ? 1 : 0);
        }}
        chartHeight={620}
        // typeData={type}
        typeData={
          Object.keys(chartData?.values?.indicator || {}).length > 0
            ? 'indicator'
            : Object.keys(chartData?.values?.industryIndicator || {}).length > 0
              ? 'industry_indicator'
              : 'local_indicator'
        }
        parentId={chartData?.parentId}
      />
    );
  }, [
    chartData,
    mappingData,
    hasMap,
    initialData,
    area,
    type,
    handleSelectTime,
    handleGetChartDataByRange,
  ]);

  return memoryChart;
};

export default ChartDisplay;
